import { createDomain, sample } from 'effector'
import { createGate } from 'effector-react'
import { AntaresFuel, AxiosErrorType } from '~/shared/api'
import { logger } from '~/shared/lib/logger'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { notificationModalOpen } from '~/shared/lib/notificationModal'

const domain = createDomain('features.refueling')

export const Gate = createGate()

export const getWidgetUrlFx = domain.createEffect<void, string, AxiosErrorType>(
  {
    async handler() {
      return await AntaresFuel.getWidgetUrl()
    },
  },
)

export const $widgetUrl = domain
  .createStore<string | null>(null)
  .on(getWidgetUrlFx.doneData, (_, url) => url)

sample({
  clock: Gate.open,
  target: getWidgetUrlFx,
})

sample({
  clock: getWidgetUrlFx.failData,
  fn(e) {
    logger.error(e)
    return {
      title: 'Ошибка',
      description: mapMessageErrors(e),
      variant: 'error' as const,
    }
  },
  target: notificationModalOpen,
})
